"use strict"

module.exports = require("./render/render")(window)
